import makeStyles from '@material-ui/core/styles/makeStyles';
var useStyles = makeStyles({
    currency: {
        fontSize: '18px',
    },
}, { name: 'Currency' });
export { useStyles };
